import { useExecutiveReport, useGlobalCurrency } from "@iliotech/data-wire";
import { useParams } from "react-router-dom";
import { ReportWidgetProps } from "../ReportWidgetProps";
import { SimpleTable } from "src/main";
import { SimpleTableColumnProps } from "src/components/SimpleTable/SimpleTable";
import cn from "classnames";
import { observer } from "mobx-react-lite";

export const ExecutiveReportWidget = observer(
  ({ periodContext }: ReportWidgetProps) => {
    const { portfolioId } = useParams();
    const { currencyFormatter } = useGlobalCurrency();
    const { data: executiveReportData } = useExecutiveReport(
      portfolioId!,
      periodContext.periodForRequest?.from!,
      periodContext.periodForRequest?.to!
    );

    const data = executiveReportData?.data || [];
    const renderCustodianCell = (props: any) => {
      const custodianName = props.dataItem["custodianName"];
      const isTotal = custodianName === "Total";
      const value = props.dataItem[props.field];
      return (
        <td
          style={{ textAlign: "left", fontWeight: isTotal ? "bold" : "normal" }}
        >
          {value}
        </td>
      );
    };
    const renderCell = (props: any) => {
      const custodianName = props.dataItem["custodianName"];
      const isTotal = custodianName === "Total";
      const value = props.dataItem[props.field];
      return (
        <td
          style={{
            textAlign: "right",
            fontWeight: isTotal ? "bold" : "normal",
          }}
        >
          {currencyFormatter(value)}
        </td>
      );
    };

    const columns: SimpleTableColumnProps[] = [
      {
        field: "custodianName",
        title: "Custodian",
        cell: renderCustodianCell,
      },
      {
        field: "inceptionNetInvestment",
        title: "Net Investment",
        cell: renderCell,
        rightAligned: true,
      },
      {
        field: "inceptionPnL",
        title: "Net P&L",
        cell: renderCell,
        rightAligned: true,
      },
      {
        field: "periodEndValue",
        title: "End Value",
        cell: renderCell,
        rightAligned: true,
      },
    ];

    const tableData = [...data];
    // Add total row
    const totals = data.reduce(
      (acc, curr) => ({
        custodianName: "Total",
        inceptionNetInvestment:
          acc.inceptionNetInvestment + curr.inceptionNetInvestment,
        inceptionPnL: acc.inceptionPnL + curr.inceptionPnL,
        periodEndValue: acc.periodEndValue + curr.periodEndValue,
      }),
      {
        custodianName: "",
        inceptionNetInvestment: 0,
        inceptionPnL: 0,
        periodEndValue: 0,
      }
    );

    //@ts-ignore
    tableData.push(totals);

    return (
      <div>
        <h6 className={cn("element-title")}>Executive Report</h6>
        <p className={"period-string"}>{periodContext.periodString}</p>
        <div style={{ marginTop: "10px" }} />
        <SimpleTable
          data={tableData}
          columns={columns}
          sortable={false}
          reorderable={false}
        />
      </div>
    );
  }
);
